/** Bound token resolution, transport and response decoding together; never retry a mutation automatically. */
export async function withCommunityRequestDeadline<T>(
  timeoutMilliseconds: number,
  signal: AbortSignal | null | undefined,
  request: (signal: AbortSignal) => Promise<T>,
): Promise<T> {
  if (signal?.aborted) throw new DOMException("Request cancelled.", "AbortError");
  const controller = new AbortController();
  let rejectDeadline!: (reason: Error) => void;
  const deadline = new Promise<never>((_resolve, reject) => { rejectDeadline = reject; });
  const abort = () => { rejectDeadline(new DOMException("Request cancelled.", "AbortError")); controller.abort(); };
  signal?.addEventListener("abort", abort, { once: true });
  const timer = setTimeout(() => {
    rejectDeadline(new DOMException("Community request timed out.", "TimeoutError")); controller.abort();
  }, timeoutMilliseconds);
  try { return await Promise.race([request(controller.signal), deadline]); }
  finally { clearTimeout(timer); signal?.removeEventListener("abort", abort); }
}
export const COMMUNITY_READ_TIMEOUT_MS = 20_000;
export const COMMUNITY_PUBLISH_TIMEOUT_MS = 120_000;
